import { isDev } from "@/utils/env";

import packageJson from "../../package.json";

const env = import.meta.env;

export const environment = {
  amplifyCookieDomain: window.location.hostname,
  apiUrl: isDev ? `/api` : `https://api.${env.VITE_FRONT_API_HOSTNAME}`,
  styxApiUrl: isDev
    ? `/styx`
    : env.VITE_STYX_API_URL || `https://styx.${env.VITE_FRONT_API_HOSTNAME}`,
  cdnUrl: `https://cdn.${env.VITE_FRONT_API_HOSTNAME}`,
  publicUrl: `https://public.${env.VITE_FRONT_API_HOSTNAME}`,
  // Where a creator's public profile lives: the monolith serves it from the project
  // domain root, so it is the bare environment host rather than a subdomain of it and
  // rather than this app's own origin.
  //
  // Derived here rather than taken from the absolute url messaging-service puts on a
  // mention, which it builds from its own configured domain — following that sends a
  // client on staging to production.
  creatorProfileUrl: `https://${env.VITE_FRONT_API_HOSTNAME}`,
  cognitoClientId: env.VITE_FRONT_APP_COGNITO_CLIENT_ID,
  cognitoRedirectSignin: `${window.location.origin}/app/oauth2/callback`,
  cognitoRedirectSignout: `${window.location.origin}/app`,
  cognitoRegion: env.VITE_FRONT_APP_COGNITO_REGION,
  cognitoUserPoolDomain: env.VITE_FRONT_APP_COGNITO_USERPOOL_DOMAIN,
  cognitoUserPoolId: env.VITE_FRONT_APP_COGNITO_USERPOOL_ID,
  cookieFirstApiKey: env.VITE_FRONT_APP_COOKIEFIRST_API_KEY,
  currentDomain: window.location.hostname,
  googleTagKey: env.VITE_FRONT_APP_GOOGLE_TAG_KEY,
  hostname: env.VITE_FRONT_APP_HOSTNAME,
  creatorUrl: env.VITE_FRONT_APP_CREATOR_URL,
  fanUrl: env.VITE_FRONT_APP_FAN_URL,
  googlePlacesApiKey: env.VITE_FRONT_APP_GOOGLE_PLACES_API_KEY,
  hotjarSiteId: env.VITE_FRONT_APP_HOTJAR_SITE_ID,
  origin: window.location.origin,
  rudderStackKey: env.VITE_FRONT_APP_RUDDERSTACK_KEY,
  rudderStackDataplane: env.VITE_FRONT_APP_RUDDERSTACK_DATAPLANE,
  sentryDsn: env.VITE_CREATORS_SENTRY_DSN,
  sentryAuth: env.VITE_SENTRY_AUTH_TOKEN,
  sentryCreatorProject: env.VITE_SENTRY_CREATOR_PROJECT,
  sentryUrl: env.VITE_SENTRY_URL,
  appVersion: JSON.stringify(packageJson.version),
  useChatStub: env.VITE_USE_CHAT_STUB !== "false",
  // Chat polling
  chatPollingEnabled: env.VITE_CHAT_POLLING_ENABLED === "true",
  chatPollingIntervalMs: Number(env.VITE_CHAT_POLLING_INTERVAL_MS) || 4000
};
